import 'declared_modules'
import 'util/console'
import 'fbSDK'
import 'GTM'
import 'util/timeSetup'
import { Suspense } from 'react'
import { renderToStaticMarkup } from 'react-dom/server'
import { Provider } from 'react-redux'
import { createRoadieUIRoots, RoadieUIProvider, ThemeMode } from 'roadie-ui'
import configureStore from 'store/configureStore'
// import * as serviceWorker from './serviceWorker'
import * as roadieWorker from './roadieWorker'
import watchWindowSize from 'windowSize'
import { HelmetProvider } from 'react-helmet-async'

import { StaticLoader } from 'components/misc/Loader'

import DrivePortalThemeProvider from 'DrivePortalThemeProvider'

import { api, MapSystem, setupEnvironment } from 'roadie-ui'
import App from './App'
import { initRoadieUISession } from 'util/server/session'
import { createRoot } from 'react-dom/client'
import { getClusterServiceUrl } from 'util/server/cluster'
import { restoreApi, setApi } from 'util/server/server'

const initialState = {}

initRoadieUISession()

export const store = configureStore(initialState)

export type StoreStateType = ReturnType<typeof store.getState>

watchWindowSize(store)

// Set app theme to system for RoadieUI
localStorage.setItem('app-theme', 'system')

// For custom api instances, this converts a string URL to a URL object
function toURL(url: string | null): URL | null {
  if (!url) {
    return null
  }

  let validUrl = url
  if (!url.startsWith('https')) {
    validUrl = 'https://' + url
  }

  if (URL.canParse(validUrl)) {
    return new URL(validUrl)
  } else {
    window.alert(`Unable to parse URL: ${url}`)
    return null
  }
}

if (import.meta.env.REACT_APP_CAN_USE_CUSTOM_API) {
  const query = new URLSearchParams(window.location.search)
  const apiURL = toURL(query.get('api'))
  if (apiURL) {
    setApi(apiURL.origin)
  } else {
    restoreApi()
  }
}

const apiUrl = getClusterServiceUrl('api')
MapSystem.setup({ renderToStaticMarkup })
setupEnvironment({
  PRODUCTION: import.meta.env.PROD,
  REACT_APP_ROADIE_API_URL: apiUrl,
  REACT_APP_MESSAGES_URL: import.meta.env.REACT_APP_MESSAGES_URL,
})
api.setApiBaseUrl(new URL(apiUrl).host)

const { elements } = createRoadieUIRoots()
const reactRoot = createRoot(elements.root)

reactRoot.render(
  <Provider store={store}>
    {/* @ts-expect-error Helmet has a weird type */}
    <HelmetProvider>
      <DrivePortalThemeProvider>
        {/* TODO: Deprecate DrivePortalThemeProvider legacy theme to RoadieUI Provider */}
        <RoadieUIProvider mode={ThemeMode.AUTO}>
          <Suspense fallback={<StaticLoader />}>
            <App />
          </Suspense>
        </RoadieUIProvider>
      </DrivePortalThemeProvider>
    </HelmetProvider>
  </Provider>
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
// serviceWorker.unregister()

if (import.meta.env.REACT_APP_ROOT_MOUNT) {
  roadieWorker.unregister()
} else {
  roadieWorker.register(store)
}
